import { render, staticRenderFns } from "./VehicleMapping.vue?vue&type=template&id=f2790792&scoped=true"
import script from "./VehicleMapping.vue?vue&type=script&lang=js"
export * from "./VehicleMapping.vue?vue&type=script&lang=js"
import style0 from "./VehicleMapping.vue?vue&type=style&index=0&id=f2790792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2790792",
  null
  
)

export default component.exports